import React from "react";
import "./Header.scss";
import github from "../../../../materials/github.svg";
import telegram from "../../../../materials/inst.svg";
import { FaTelegramPlane } from "react-icons/fa";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import AnchorLink from "react-anchor-link-smooth-scroll";

export default function Header() {
  return (
    <div className="header__container">
      <div className="btn1 btn1--socials" style={{ cursor: "default" }}>
        <a href="https://github.com/ban3a1">
          <AiFillGithub color="white" />
        </a>
        <a href="https://t.me/nikitatemniy">
          <FaTelegramPlane color="white" />
        </a>
        <a href="https://www.linkedin.com/in/nikita-nechepurenko-6b410b213/">
          <AiFillLinkedin color="white" />
        </a>
      </div>
    </div>
  );
}
